import React from 'react';
import SvgIcon from './SvgIcon';

const DoubleArrowRight = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M2.666.5L15.24 11.626a.5.5 0 010 .748L2.666 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M9.333.5l12.574 11.126a.5.5 0 010 .748L9.333 23.5"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

DoubleArrowRight.displayName = 'DoubleArrowRightIcon';

export default DoubleArrowRight;
